import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Star, Award, Clock, Shield, Sparkles, Building2, Droplets, Hammer, Briefcase, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function HomePage() {
  return <div className="flex flex-col min-h-screen" data-id="element-302">
      {/* Hero Section */}
      <section className="relative bg-blue-900 text-white overflow-hidden min-h-[85vh] sm:min-h-[75vh] lg:min-h-[85vh] flex items-center" data-id="element-303">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0" data-id="element-304">
          <img src="https://cdn.magicpatterns.com/uploads/mUxgfVLTYLb2q64ynkoGmb/pexels-tima-miroshnichenko-6197108.jpg" alt="Professionelles Reinigungsteam" className="w-full h-full object-cover" data-id="element-305" />
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/90 via-blue-800/85 to-blue-900/90" data-id="element-306"></div>
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-307">
          <div className="text-center lg:text-left max-w-3xl mx-auto lg:mx-0" data-id="element-308">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-medium mb-6" data-id="element-309">
              <Star className="w-4 h-4 text-amber-400 mr-2" fill="currentColor" data-id="element-310" />
              Über 50 Jahre Erfahrung
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6" data-id="element-311">
              Professionelle
              <br data-id="element-312" />
              <span className="text-emerald-400" data-id="element-313">Gebäudereinigung</span>
              <br data-id="element-314" />
              in Aachen
            </h1>

            <p className="text-lg sm:text-xl text-blue-50 mb-8 leading-relaxed" data-id="element-315">
              Genial gereinigt - Seit über 50 Jahren Ihr zuverlässiger Partner
              für Sauberkeit, Hygiene und Werterhalt.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start mb-12" data-id="element-316">
              <Link to="/kontakt" className="w-full sm:w-auto" data-id="element-317">
                <Button size="lg" variant="secondary" className="w-full sm:w-auto shadow-xl" data-id="element-318">
                  Kostenloses Angebot
                  <ArrowRight className="ml-2 w-5 h-5" data-id="element-319" />
                </Button>
              </Link>
              <Link to="/leistungen" className="w-full sm:w-auto" data-id="element-320">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-blue-900 backdrop-blur-sm" data-id="element-321">
                  Leistungen entdecken
                </Button>
              </Link>
            </div>
          </div>

          {/* Trust Badges - Optimized for Mobile */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 max-w-3xl mx-auto lg:mx-0" data-id="element-322">
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20 hover:bg-white/15 transition-colors" data-id="element-323">
              <Shield className="w-7 h-7 text-emerald-400 mx-auto mb-2" data-id="element-324" />
              <p className="text-xs sm:text-sm font-semibold" data-id="element-325">Meisterbetrieb</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20 hover:bg-white/15 transition-colors" data-id="element-326">
              <Award className="w-7 h-7 text-amber-400 mx-auto mb-2" data-id="element-327" />
              <p className="text-xs sm:text-sm font-semibold" data-id="element-328">50+ Jahre</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20 hover:bg-white/15 transition-colors" data-id="element-329">
              <Sparkles className="w-7 h-7 text-blue-300 mx-auto mb-2" data-id="element-330" />
              <p className="text-xs sm:text-sm font-semibold" data-id="element-331">Innovation</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 text-center border border-white/20 hover:bg-white/15 transition-colors" data-id="element-332">
              <Clock className="w-7 h-7 text-white mx-auto mb-2" data-id="element-333" />
              <p className="text-xs sm:text-sm font-semibold" data-id="element-334">24h Service</p>
            </div>
          </div>
        </div>

        {/* Subtle bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-gray-50 to-transparent" data-id="element-335"></div>
      </section>

      {/* Services Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-336">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-337">
          <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-338">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-339">
              Unsere Dienstleistungen
            </h2>
            <p className="text-base sm:text-lg text-gray-600" data-id="element-340">
              Umfassende Reinigungslösungen für Gewerbe, Industrie und
              Privathaushalte.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-341">
            {[{
            icon: <Building2 className="w-8 h-8 text-emerald-500" data-id="element-342" />,
            title: 'Gebäudereinigung',
            desc: 'Unterhalts-, Grund- und Bedarfsreinigung für Büros, Praxen und Gewerberäume.'
          }, {
            icon: <Droplets className="w-8 h-8 text-emerald-500" data-id="element-343" />,
            title: 'Glasreinigung',
            desc: 'Streifenfreie Sauberkeit für Fenster, Glasfassaden und Wintergärten.'
          }, {
            icon: <Sparkles className="w-8 h-8 text-emerald-500" data-id="element-344" />,
            title: 'Teppich & Polster',
            desc: 'Tiefenreinigung für langlebige und frische Textilbeläge und Möbel.'
          }, {
            icon: <Hammer className="w-8 h-8 text-emerald-500" data-id="element-345" />,
            title: 'Baureinigung',
            desc: 'Fachgerechte Beseitigung von Handwerkerschmutz bei Neu- und Umbauten.'
          }, {
            icon: <Shield className="w-8 h-8 text-emerald-500" data-id="element-346" />,
            title: 'Hygiene & Desinfektion',
            desc: 'Professionelle Desinfektion und Beratung durch staatlich geprüfte Desinfektoren.'
          }, {
            icon: <Clock className="w-8 h-8 text-emerald-500" data-id="element-347" />,
            title: '24h Notdienst',
            desc: 'Rund um die Uhr erreichbar für Notfälle und dringende Einsätze.'
          }].map((service, index) => <Card key={index} hover className="p-6 sm:p-8 border-t-4 border-t-transparent hover:border-t-emerald-500" data-id="element-348">
                <div className="bg-emerald-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mb-4 sm:mb-6" data-id="element-349">
                  {service.icon}
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3" data-id="element-350">
                  {service.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6" data-id="element-351">
                  {service.desc}
                </p>
                <Link to="/leistungen" className="text-blue-700 font-medium hover:text-blue-900 inline-flex items-center text-sm sm:text-base" data-id="element-352">
                  Mehr erfahren <ArrowRight className="w-4 h-4 ml-1" data-id="element-353" />
                </Link>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Innovation Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-354">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-355">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16" data-id="element-356">
            <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-357">
              <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-358">
                <img src="https://images.unsplash.com/photo-1527977966376-1c8408f9f108?auto=format&fit=crop&q=80" alt="CleanCopter Drohnentechnologie" className="w-full object-cover h-64 sm:h-80 lg:h-96" data-id="element-359" />
                <div className="absolute bottom-4 right-4 bg-white p-3 sm:p-4 rounded-lg shadow-lg" data-id="element-360">
                  <p className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-361">
                    In Kooperation mit
                  </p>
                  <p className="text-blue-800 font-bold text-base sm:text-lg" data-id="element-362">
                    FH Aachen
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-363">
              <div className="inline-block px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4" data-id="element-364">
                Innovation Made in Aachen
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-365">
                Der CleanCopter:
                <br data-id="element-366" />
                <span className="text-blue-700" data-id="element-367">Reinigung der Zukunft</span>
              </h2>
              <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6" data-id="element-368">
                In Zusammenarbeit mit der Fachhochschule Aachen entwickeln wir
                den CleanCopter stetig weiter - eine patentierte
                Reinigungsdrohne für Glasfassaden.
              </p>
              <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8" data-id="element-369">
                {['Sicherer Einsatz in großen Höhen', 'Kosteneffizient ohne Gerüstbau', 'Umweltschonend und präzise', 'Patentierte Technologie'].map((item, i) => <li key={i} className="flex items-center text-sm sm:text-base text-gray-700" data-id="element-370">
                    <CheckCircle2 className="w-5 h-5 text-emerald-500 mr-3 flex-shrink-0" data-id="element-371" />
                    {item}
                  </li>)}
              </ul>
              <Link to="/cleancopter" data-id="element-372">
                <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-373">
                  Alles zum CleanCopter
                  <ArrowRight className="ml-2 w-5 h-5" data-id="element-374" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Signals */}
      <section className="py-12 sm:py-16 bg-blue-900 text-white" data-id="element-375">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
          <div className="text-center mb-8 sm:mb-12" data-id="element-377">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4" data-id="element-378">
              Warum Lissowski?
            </h2>
            <p className="text-sm sm:text-base text-blue-200 max-w-2xl mx-auto" data-id="element-379">
              Wir verbinden traditionelles Handwerk mit modernster Technik und
              höchsten Qualitätsstandards.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8" data-id="element-380">
            {[{
            label: 'Über 50 Jahre Erfahrung',
            icon: <Award className="w-8 sm:w-10 h-8 sm:h-10 text-amber-400" data-id="element-381" />
          }, {
            label: 'Innungsfachbetrieb',
            icon: <Shield className="w-8 sm:w-10 h-8 sm:h-10 text-emerald-400" data-id="element-382" />
          }, {
            label: 'Geprüfte Desinfektoren',
            icon: <CheckCircle2 className="w-8 sm:w-10 h-8 sm:h-10 text-blue-400" data-id="element-383" />
          }, {
            label: '24h Service',
            icon: <Clock className="w-8 sm:w-10 h-8 sm:h-10 text-white" data-id="element-384" />
          }].map((item, i) => <div key={i} className="bg-blue-800/50 p-4 sm:p-6 rounded-xl border border-blue-700 text-center" data-id="element-385">
                <div className="flex justify-center mb-3 sm:mb-4" data-id="element-386">
                  {item.icon}
                </div>
                <h3 className="font-bold text-sm sm:text-base lg:text-lg" data-id="element-387">
                  {item.label}
                </h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-24 bg-white" data-id="element-388">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-389">
          <div className="bg-gray-50 rounded-2xl sm:rounded-3xl p-6 sm:p-12 lg:p-16 text-center border border-gray-100 shadow-sm relative overflow-hidden" data-id="element-390">
            <div className="absolute top-0 left-0 w-full h-1 sm:h-2 bg-gradient-to-r from-blue-500 via-emerald-500 to-blue-500" data-id="element-391"></div>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-392">
              Bereit für{' '}
              <span className="text-blue-700" data-id="element-393">genial gereinigte</span> Räume?
            </h2>
            <p className="text-base sm:text-xl text-gray-600 mb-8 sm:mb-10 max-w-2xl mx-auto" data-id="element-394">
              Kontaktieren Sie uns für ein unverbindliches Angebot. Wir beraten
              Sie gerne persönlich vor Ort.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4" data-id="element-395">
              <Link to="/kontakt" className="w-full sm:w-auto" data-id="element-396">
                <Button size="lg" variant="primary" className="w-full sm:w-auto shadow-lg shadow-blue-900/20" data-id="element-397">
                  Jetzt Kontakt aufnehmen
                </Button>
              </Link>
              <a href="tel:0241512746" className="w-full sm:w-auto" data-id="element-398">
                <Button size="lg" variant="outline" className="w-full sm:w-auto" data-id="element-399">
                  <Phone className="w-5 h-5 mr-2" data-id="element-400" />
                  0241 512746
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}